import appName from "./appName.js";
import appPermissions from "./appPermissions.js";
import appStateContent from "./appStateContent.js";
import appStateSchema from "./appStateSchema.js";
import collectionCategoryName from "./collectionCategoryName.js";
import collectionName from "./collectionName.js";
import contentSummary from "./contentSummary.js";
import defaultDocumentViewUiOptions from "./defaultDocumentViewUiOptions.js";
import globalSettings from "./globalSettings.js";
import httpOrigin from "./httpOrigin.js";
import icon from "./icon.js";
import id from "./id.js";

export default {
  appName,
  appPermissions,
  appStateContent,
  appStateSchema,
  collectionCategoryName,
  collectionName,
  contentSummary,
  defaultDocumentViewUiOptions,
  globalSettings,
  httpOrigin,
  icon,
  id,
};
